import Provider from "../components/Provider";

function HomePage() {
    return (
        <>
            <Provider />
        </>
    );
}

export default HomePage;
